
import QRCode from 'qrcode';

export function downloadQR(qrLink) {

    QRCode.toDataURL(qrLink, { errorCorrectionLevel: 'H' }, function (err, url) {
        if (err) {
            console.error(err);
            return;
        }

        // Crear un enlace para la descarga
        const downloadLink = document.createElement('a');
        downloadLink.href = url;
        downloadLink.download = 'myReport!n-qr-code.png';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    });
};

export async function generateQRBase64(qrLink) {
    try {
        const urlBase64 = await QRCode.toDataURL(qrLink, { errorCorrectionLevel: 'H' });
        return urlBase64;
    } catch (error) {
        console.error(error);
        throw error;
    }
}


